import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Expense } from 'core/application/employeeDashboard/summary/reimbursementRequests/getExpenses'
import { ExpenseStatus } from 'core/domain/expenses/expenseStatus'

import Popover from 'common/components/dataDisplay/Popover'
import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'

import { ROUTE_PATHS } from '../../../../common/routePaths'

interface MoreActionsProps {
  expense: Expense
  onDelete: (expenseId: string) => void
  onViewFiles: (expenseId: string) => void
  viewAttachments?: boolean
  planPeriodId: string
}

const MoreActionsPerks: React.FC<MoreActionsProps> = ({
  expense,
  onDelete,
  onViewFiles,
  viewAttachments,
  planPeriodId,
}) => {
  const { t: translate } = useTranslation(['ee-dashboard', 'translation'])
  const history = useHistory()

  const getEditActionContent = () => {
    if (expense.expenseStatus === ExpenseStatus.Verified || expense.expenseStatus === ExpenseStatus.Ineligible)
      return null

    return (
      <p
        className="color-gray-7 pointer"
        onClick={() => {
          history.push(
            `${ROUTE_PATHS.ELIGIBLE_EMPLOYEE_SUBMIT_EXPENSE}?planPeriodId=${planPeriodId}&expenseCategoryId=${expense.expenseNumber}&expenseId=${expense.id}`,
          )
        }}
      >
        <Icon type="far fa-pencil-alt" fontAwesome className="mr-8" /> {translate('translation:general.edit')}
      </p>
    )
  }

  const getDeleteActionContent = () => {
    if (expense.expenseStatus === ExpenseStatus.Verified) return null
    return (
      <p className="color-red-6 pointer" onClick={() => onDelete(expense.id)}>
        <Icon type="far fa-trash-alt" fontAwesome className="mr-8" /> {translate('translation:general.delete')}
      </p>
    )
  }

  const getViewFilesActionContent = () => {
    return (
      <p className="color-gray-7 pointer" onClick={() => onViewFiles(expense.id)}>
        <Icon type="far fa-eye" fontAwesome className="mr-8" /> {translate('reimbursement-requests.view-files-label')}
      </p>
    )
  }

  return (
    <Popover
      content={
        <div>
          {(expense.expenseStatus === ExpenseStatus.AwaitingReview || ExpenseStatus.AwaitingAdminReview) &&
            getEditActionContent()}
          {viewAttachments && getViewFilesActionContent()}
          {getDeleteActionContent()}
        </div>
      }
      trigger="click"
      placement="bottomRight"
      overlayClassName="expense_popover_overlay"
    >
      <Button htmlType="button" shape="circle">
        <Icon type="far fa-ellipsis-h" fontAwesome className="color-gray-8" />
      </Button>
    </Popover>
  )
}

export default MoreActionsPerks
